import { apiClient } from 'api-client';
import { makeAutoObservable } from 'mobx';
import { RootStore } from './root-store';
import posthog from 'posthog-js';
import { Prediction } from '@engelvoelkersamericas/api';

/**
 * Houses frequently searched areas and recent searches. Will expand to contain search filters for properties search in the future.
 */
export class SearchStore {
  public frequentlySearchedAreas: Record<string, any> | null = null;
  public recentSearches: Prediction[] = [];

  constructor(private rootStore: RootStore) {
    makeAutoObservable(this);
  }

  public setFrequentlySearchedAreas = (areas: Record<string, any> | null): void => {
    this.frequentlySearchedAreas = areas;
  };

  public handleSaveSearchLog = async (prediction: Prediction) => {
    const shopIds = this.rootStore.shopStore.shopIds;
    const normalizedSearch: Partial<Prediction> = prediction;
    delete normalizedSearch['count'];
    await apiClient.saveFrequentlySearchedArea({
      saveFrequentlySearchedAreaDto: {
        searchTerm: JSON.stringify(normalizedSearch),
        locationType: prediction.type as {},
        shopOrShopGroupId: shopIds ? shopIds[0] : 'americas',
      },
    });

    // Uncomment when testing FSA
    // await apiClient.aggregateSearchedAreas({
    //   getFrequentlySearchedAreaDto: {
    //     shopOrShopGroupId: shopIds ? shopIds[0] : 'americas',
    //   },
    // });
  };

  public loadRecentSearches = (): void => {
    if (typeof window === 'undefined') {
      return;
    }
    const savedSearches = localStorage.getItem('recentSearches');
    this.recentSearches = savedSearches ? JSON.parse(savedSearches) : [];
  };

  public saveRecentSearch = (prediction: Prediction) => {
    const updatedSearches = [
      prediction,
      ...this.recentSearches.filter((s) => s.value !== prediction.value),
    ];
    if (updatedSearches.length > 3) {
      updatedSearches.pop(); // Keep only the last 3 searches
    }
    this.recentSearches = updatedSearches;
    localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
  };
}
